import { AnswerType } from './Answer'

export enum SurveyStatAction {
  SurveyStart = 'SurveyStart',
  SurveyEnd = 'SurveyEnd',
  QuestionPrev = 'QuestionPrev',
  QuestionNext = 'QuestionNext',
  QuestionStart = 'QuestionStart',
  QuestionEnd = 'QuestionEnd',
  AnswerStat = 'AnswerStat',
}

export type SurveyStatRequest = {
  visitorId: string
  action: SurveyStatAction
  questionId?: string
  start: string
  end: string
  value?: AnswerType
}
